import React from "react";
import { fileUrl } from "@/lib/api";

export function parseYouTube(url) {
  if (!url) return null;
  const m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
  return m ? m[1] : null;
}

export function VideoEmbed({ video, className = "" }) {
  if (!video || !video.url) return null;
  if (video.type === "youtube") {
    const id = parseYouTube(video.url);
    if (!id) return null;
    return (
      <div className={`relative aspect-video w-full overflow-hidden rounded-xl border border-border ${className}`}>
        <iframe
          className="absolute inset-0 h-full w-full"
          src={`https://www.youtube.com/embed/${id}`}
          title="Intro video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <video src={fileUrl(video.url)} controls className={`w-full rounded-xl border border-border ${className}`} />
  );
}
